import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { CarCare, CarCareQueryParams, DataUpdateCarCare } from "../types";

interface CarCareState {
  carCareCategories: Array<CarCare>;
  carCareCategoriesTotal: number;
  carCare?: CarCare;
}

const initialState: CarCareState = {
	carCareCategories: [],
	carCareCategoriesTotal: 0,
};

export const carCareSlice = createSlice({
	name: "carCare",
	initialState,
	reducers: {
		setCarCares: (state, action) => {
			state.carCareCategories = action.payload.data;
			state.carCareCategoriesTotal = action.payload.total;
		},
		setCarCare: (state, action) => {
			state.carCare = action.payload.data;
		},
		changeStatusCarCare: (state, action) => {
			const { id, status } = action.payload;
			const index = state.carCareCategories.findIndex(el => el._id === id);
			state.carCareCategories[index].status = status;
		},
	},
});

export const selectCarCares = (state: RootState) => state.carCare.carCareCategories;
export const selectCarCaresTotal = (state: RootState) => state.carCare.carCareCategoriesTotal;
export const selectCarCare = (state: RootState) => state.carCare.carCare;

export const { setCarCares, setCarCare, changeStatusCarCare } = carCareSlice.actions;

export interface GetCarCaresAsyncPayload {
  query: CarCareQueryParams;
	callback?: () => void;
}
export interface GetCarCareDetailsPayload {
  id: string;
	callback?: (carCare?: CarCare) => void;
}
export interface CreateCarCarePayload {
  data: CarCare;
  callback: () => void;
}
export interface UpdateCarCarePayload {
  id: string;
  data: DataUpdateCarCare;
	callback?: () => void;
}

export interface UpdateCarCareStatusPayload {
  id: string;
  status: string;
	callback?: () => void;
}

export const getCarCaresAsync = createAction(
	"carCare/getCarCares",
	(payload: GetCarCaresAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getCarCareDetailsAsync = createAction(
	"carCare/getCarCareDetails",
	(payload: GetCarCareDetailsPayload) => ({
		payload: payload,
	})
);

export const createNewCarCareAsync = createAction(
	"carCare/createNewCarCare",
	(payload: CreateCarCarePayload) => ({
		payload: payload,
	})
);

export const updateCarCareAsync = createAction(
	"carCare/updateCarCare",
	(payload: UpdateCarCarePayload) => ({
		payload: payload,
	})
);



export default carCareSlice.reducer;
